import { urls, baseUrl, roleId, optionsStatus } from '../constants/app';
import moment from 'moment';
import request from './utils/request';
import axios from 'axios';
import { setError, resetError } from './errors';
import { fetchCouriers } from './user';
import { notifyAboutNewOrder } from './notifications';
axios.defaults.baseURL = baseUrl;

export function fetchGoods() {
    return (dispatch, getState) => {
    const goods = getState().good.list;
    if (goods.length === 0) {
        dispatch({ type: 'SET_LOADER', field: 'goods', value: true });
        return axios.get('https://xn--161-9cd8an1avep9c.xn--p1ai/api/items')
            .then((response) => {
                dispatch({ type: 'SET_GOODS', goods: response.data });
                dispatch({ type: 'SET_LOADER', field: 'goods', value: false });
                return response;
            })
            .catch(error => {
                dispatch(setError(error, 'global'));
                dispatch({ type: 'SET_LOADER', field: 'goods', value: false });
                return null
            });
        }
    }
}

export function fetchOrders(dataParams = {}, isArchive, getCouriers) {
    return (dispatch, getState) => {
        const getOrderCity = (order) => {
            if (order.city) return order.city;
            if (order.point && order.point.city) return order.point.city;
            if (order.zone && order.zone.city) return order.zone.city;
            return;
        }
        
        dispatch({ type: 'SET_LOADER', field: 'orders', value: true });
        const paging = getState().orders.paging;
        const sorting = getState().orders.sorting;
        const user = getState().user.info;
        const filters = getState().orders.filters;
        
        if(!filters.createdEndDate && !isArchive) filters.createdEndDate = new Date().setHours(23, 59, 59, 999)
        
        if(!filters.createdStartDate && !isArchive) filters.createdStartDate = new Date().setHours(0, 0, 0, 0)

        const params = { ...dataParams };

        if (filters.city) {
            dataParams['city'] = filters.city.value;//передается city, а не city.id, тк на стороне api идет sql запрос, а city это связь, а не данные
            params['city'] = filters.city.value;
        }

        if (filters.courier) {
            dataParams['courierId'] = filters.courier.value;
            params['courierId'] = filters.courier.value;
        }

        if (filters.consumption && filters.consumption.value) {
            dataParams['consumption'] = filters.consumption.value;
            params['consumption'] = filters.consumption.value;
        }

        if (filters.cities && filters.cities.length > 0) {
            const citiesIds = filters.cities.map((city) => parseInt(city.value)).filter((item) => item);
            if (citiesIds && citiesIds.length > 0) {
                dataParams['citiesIds'] = citiesIds;
                params['citiesIds'] = citiesIds;
            }
        }

        if (filters.statuses && filters.statuses.length > 0) {
            const statusesValues = filters.statuses.map((status) => status.value).filter((item) => item);
            if (statusesValues && statusesValues.length > 0) {
                dataParams['statuses'] = statusesValues;
                params['statuses'] = statusesValues;
            }
        }

        if (filters.zone) {
            dataParams['zone_null'] = false;
            params['zone_null'] = false;
        }

        if (filters.phone) {
            dataParams['phone'] = filters.phone;
            params['phone'] = filters.phone;
        }

        if (filters.id) {
            dataParams['id'] = filters.id;
            params['id'] = filters.id;
        }

        if (filters.payment && filters.payment.value) {
            dataParams['payment'] = filters.payment.value;
            params['payment'] = filters.payment.value;
        }

        if (filters.name) {
            dataParams['userName'] = filters.name;
            params['userName'] = filters.name;
        }

        if (filters.status) {
            dataParams['status'] = filters.status.value;
            params['status'] = filters.status.value;
        }

        if (filters.source) {
            dataParams['source'] = filters.source.value;
            params['source'] = filters.source.value;
        }

        if (filters.createdStartDate) {
            dataParams['created_at_gte'] = moment(filters.createdStartDate).format('YYYY-MM-DD HH:mm:ss');
            params['created_at_gte'] = moment(filters.createdStartDate).format('YYYY-MM-DD HH:mm:ss');
        }

        if (filters.createdEndDate) {
            dataParams['created_at_lte'] = moment(filters.createdEndDate).format('YYYY-MM-DD HH:mm:ss');
            params['created_at_lte'] = moment(filters.createdEndDate).format('YYYY-MM-DD HH:mm:ss');
        }

        if(params.user) {
            dataParams['created_at_gte'] = null;
            params['created_at_gte'] = null;
            dataParams['created_at_lte'] = null;
            params['created_at_lte'] = null;
        }

        if(user.role.id === roleId.courier) {
            dataParams.courierId = user.id;
            params.courierId = user.id;
        }

        params['_start'] = paging.start;
        params['_limit'] = (user.role.id === roleId.admin && paging.localLimit) ? paging.localLimit : paging.limit;
        params['_sort'] = `${sorting.field}:${sorting.type}`;

        const url = isArchive ? urls.archive : urls.orders;

        if(user.points.length > 0 || filters.points.length > 0) {
            let pointsId = null;

            if(!filters.points || filters.points.length === 0) {
                pointsId = user.points.map(item => item.id);
            } else {
                pointsId = filters.points.map((point) => point.value);
            }

            dataParams['pointsId'] = pointsId;
            params['pointsId'] = pointsId;
        }

        if(!params.user && [roleId.admin, roleId.cashier, roleId.manager, roleId.regionalDirector, roleId.operationDirector, roleId.marketingSpecialist, roleId.chiefMarketingSpecialist, roleId.chiefCommoditySpecialist].includes(user.role.id) && !isArchive)
            request({ method: 'get', url: urls.orders+'/stats-orders-of-head', params: dataParams })
                .then(result => {
                    dispatch({ type: 'SET_STATISTICS', name: 'ordersOfHead', result });
                    dispatch({ type: 'SET_STATISTICS_LOADER', name: 'ordersOfHead', loading: false });
                })
                .catch(error => {
                    dispatch({ type: 'SET_LOADER', name: 'ordersOfHead', loading: false });
                });

        request({ method: 'get', url: url+'/count/crm', params: dataParams })
            .then(result => {
                dispatch({ type: 'SET_ORDERS_COUNT', count: result });
                return;
            })
            .then(async () => {
                const cities = getState().handbook.cities;                
                const zones = getState().handbook.zones;
                const points = getState().handbook.filials;
                const avaibleZones = [ ...zones ];
                const avaiblePoints = [ ...points ];

                return request({ method: 'get', url: url+'/crm', params }).then(async (response) => {
                    const orders = await Promise.all(response.map(async (order) => {
                        if(order.city && !order.city.id) {
                            let checkCity = cities.find((city) => city.id === order.city)
                            if(checkCity) {
                                order.city = checkCity;
                            } else {
                                request({ method: 'get', url: `${urls.cities}/${order.city}` })
                                .then((response) => order.city = response)
                                .catch((error) => {
                                    console.error(error);
                                    order.city = null;
                                });
                            }
                        }

                        if(order.point && !order.point.id) {
                            let checkPoint = avaiblePoints.find((point) => point.id === order.point);
                            if(checkPoint) {
                                order.point = checkPoint;
                            } else {
                                await request({ method: 'get', url: `${urls.filials}/${order.point}` })
                                .then((response) => {
                                    order.point = response;
                                    avaiblePoints.push(response);
                                })
                                .catch((error) => {
                                    console.error(error);
                                    order.point = null;
                                });
                            }
                        }

                        if(order.zone && !order.zone.id) {
                            let checkZone = avaibleZones.find((zone) => zone.id === order.zone);
                            if(checkZone) {
                                order.zone = checkZone;
                                order.point = checkZone.point;
                            } else {
                                await request({ method: 'get', url: `${urls.zone}/${order.zone}` })
                                .then((response) => {
                                    order.zone = response;
                                    order.point = response.point;
                                    avaibleZones.push(response);
                                })
                                .catch((error) => {
                                    console.error(error);
                                    order.zone = null;
                                });
                            }
                        }

                        order.paymentData = JSON.parse(order.paymentData);
                        order.goods = order.goods ? JSON.parse(order.goods) : [];
                        order.cashback = JSON.parse(order.cashback);
                        order.aggData = JSON.parse(order.aggData);
                        order.tags = order.tags ? JSON.parse(order.tags) : null;
                        order.city = getOrderCity(order);
                        if (!order.internalComment && order.comment) order.internalComment = order.comment; 

                        return order;
                    }));
                    dispatch({ type: 'SET_ORDERS', orders: orders });
                    if (getCouriers && orders.length > 0) {
                        dispatch(fetchCouriers(orders, user.role.id)).then((res) => {
                            dispatch({ type: 'SET_COURIERS', data: res });
                        })
                    }
                    dispatch({ type: 'SET_LOADER', field: 'orders', value: false });
                })
            })
            .catch(error => {
                dispatch(setError(error, 'orders'));
                dispatch({ type: 'SET_LOADER', field: 'orders', value: false });
            });
    }
}

export function silentFetchOrders(dataParams = {}, isArchive, getCouriers) {
    return (dispatch, getState) => {
        const paging = getState().orders.paging;
        const sorting = getState().orders.sorting;
        const user = getState().user.info;
        const filters = getState().orders.filters;

        if(!filters.createdEndDate && !isArchive) filters.createdEndDate = new Date().setHours(23, 59, 59, 999)

        if(!filters.createdStartDate && !isArchive) filters.createdStartDate = new Date().setHours(0, 0, 0, 0)

        const params = { ...dataParams };

        if (filters.city) {
            dataParams['city'] = filters.city.value;
            params['city'] = filters.city.value;
        }

        if (filters.courier) {
            dataParams['courierId'] = filters.courier.value;
            params['courierId'] = filters.courier.value;
        }

        if (filters.consumption && filters.consumption.value) {
            dataParams['consumption'] = filters.consumption.value;
            params['consumption'] = filters.consumption.value;
        }

        if (filters.cities && filters.cities.length > 0) {
            const citiesIds = filters.cities.map((city) => parseInt(city.value)).filter((item) => item);
            if (citiesIds && citiesIds.length > 0) {
                dataParams['citiesIds'] = citiesIds;
                params['citiesIds'] = citiesIds;
            }
        }

        if (filters.statuses && filters.statuses.length > 0) {
            const statusesValues = filters.statuses.map((status) => status.value).filter((item) => item);
            if (statusesValues && statusesValues.length > 0) {
                dataParams['statuses'] = statusesValues;
                params['statuses'] = statusesValues;
            }
        }

        if (filters.zone) {
            dataParams['zone_null'] = false;
            params['zone_null'] = false;
        }

        if (filters.phone) {
            dataParams['phone'] = filters.phone;
            params['phone'] = filters.phone;
        }

        if (filters.id) {
            dataParams['id'] = filters.id;
            params['id'] = filters.id;
        }

        if (filters.payment && filters.payment.value) {
            dataParams['payment'] = filters.payment.value;
            params['payment'] = filters.payment.value;
        }

        if (filters.name) {
            dataParams['userName'] = filters.name;
            params['userName'] = filters.name;
        }

        if (filters.status) {
            dataParams['status'] = filters.status.value;
            params['status'] = filters.status.value;
        }

        if (filters.source) {
            dataParams['source'] = filters.source.value;
            params['source'] = filters.source.value;
        }

        if (filters.createdStartDate) {
            dataParams['created_at_gte'] = moment(filters.createdStartDate).format('YYYY-MM-DD HH:mm:ss');
            params['created_at_gte'] = moment(filters.createdStartDate).format('YYYY-MM-DD HH:mm:ss');
        }

        if (filters.createdEndDate) {
            dataParams['created_at_lte'] = moment(filters.createdEndDate).format('YYYY-MM-DD HH:mm:ss');
            params['created_at_lte'] = moment(filters.createdEndDate).format('YYYY-MM-DD HH:mm:ss');
        }

        if(params.user) {
            dataParams['created_at_gte'] = null;
            params['created_at_gte'] = null;
            dataParams['created_at_lte'] = null;
            params['created_at_lte'] = null;
        }

        if(user.role.id === roleId.courier) {
            dataParams.courierId = user.id;
            params.courierId = user.id;
        }

        params['_start'] = paging.start;
        params['_limit'] = (user.role.id === roleId.admin && paging.localLimit) ? paging.localLimit : paging.limit;
        params['_sort'] = `${sorting.field}:${sorting.type}`;

        const url = isArchive ? urls.archive : urls.orders;

        if(user.points.length > 0 || filters.points.length > 0) {
            let pointsId = null;

            if(!filters.points || filters.points.length === 0) {
                pointsId = user.points.map(item => item.id);
            } else {
                pointsId = filters.points.map((point) => point.value);
            }

            dataParams['pointsId'] = pointsId;
            params['pointsId'] = pointsId;
        }

        if(!params.user && [roleId.admin, roleId.cashier, roleId.manager, roleId.regionalDirector, roleId.operationDirector, roleId.marketingSpecialist, roleId.chiefMarketingSpecialist].includes(user.role.id) && !isArchive)
            request({ method: 'get', url: urls.orders+'/stats-orders-of-head', params: dataParams })
                .then(result => {
                    dispatch({ type: 'SET_STATISTICS', name: 'ordersOfHead', result });
                    dispatch({ type: 'SET_STATISTICS_LOADER', name: 'ordersOfHead', loading: false });
                })
                .catch(() => {});

        request({ method: 'get', url: url+'/count/crm', params: dataParams })
            .then(result => {
                dispatch({ type: 'SET_ORDERS_COUNT', count: result });
                return;
            })
            .then(async () => {
                const cities = getState().handbook.cities;
                const zones = getState().handbook.zones;

                return request({ method: 'get', url: url+'/crm', params }).then(async (response) => {
                    const orders = await Promise.all(response.map(async (order) => {
                        if(order.city && !order.city.id) {
                            let checkCity = cities.find((city) => city.id === order.city)
                            if(checkCity) {
                                order.city = checkCity;
                            } else {
                                request({ method: 'get', url: `${urls.cities}/${order.city}` })
                                .then((response) => order.city = response);
                            }
                        }

                        if(order.point && !order.point.id) {
                            let checkPoint = user.points.find((point) => point.id === order.point);
                            if(checkPoint) {
                                order.point = checkPoint;
                            } else {
                                await request({ method: 'get', url: `${urls.filials}/${order.point}` })
                                .then((response) => order.point = response);
                            }
                        }

                        if(order.zone && !order.zone.id) {
                            let checkZone = zones.find((zone) => zone.id === order.zone);
                            if(checkZone) {
                                order.zone = checkZone;
                            } else {
                                await request({ method: 'get', url: `${urls.zone}/${order.zone}` })
                                .then((response) => order.zone = response)
                                .catch((err) => order.zone = null);
                            }
                        }

                        order.paymentData = JSON.parse(order.paymentData);
                        order.goods = order.goods ? JSON.parse(order.goods) : [];
                        order.cashback = JSON.parse(order.cashback);
                        order.aggData = JSON.parse(order.aggData);
                        order.tags = order.tags ? JSON.parse(order.tags) : null;

                        return order;
                    }));
                    const currentOrders = getState().orders.list;
                    const currentIds = new Set(currentOrders.map(o => o.id));
                    const newOrders = orders.filter(o => !currentIds.has(o.id));

                    dispatch({ type: 'SET_ORDERS', orders: orders });

                    newOrders.forEach(order => {
                        dispatch(notifyAboutNewOrder(order));
                    });

                    if (getCouriers && orders.length > 0) {
                        dispatch(fetchCouriers(orders, user.role.id)).then((res) => {
                            dispatch({ type: 'SET_COURIERS', data: res });
                        })
                    }
                })
            })
            .catch(() => {});
    }
}

export function deleteOrder(id, isArchive) {
    return (dispatch) => {
    const url = isArchive ? urls.archive : urls.orders;
    dispatch({ type: 'SET_LOADER', field: 'orders', value: true });
    dispatch(resetError('orders'));
    return request({ method: 'delete', url:`${url}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'orders', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 507 }, 'orders'));
            dispatch({ type: 'SET_LOADER', field: 'orders', value: false });
            return false;
        });
    }
}

export function setOrdersFilters(filters) {
    return dispatch => {
        dispatch({ type: 'SET_ORDERS_FILTERS', filters });
    }
}

export function updateOrder(id, data, isArchive) {
    return (dispatch) => {
    const url = isArchive ? urls.archive : urls.orders;
    dispatch({ type: 'SET_LOADER', field: 'order', value: true });
    dispatch(resetError('orders'));

        return request({ method: 'put', url: `${url}/${id}`, data })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'order', value: false });
                return true;
            })
            .catch(error => {
                dispatch(setError({ status: 508 }, 'orders'));
                dispatch({ type: 'SET_LOADER', field: 'order', value: false });
                return false;
            });
    
    }
}

export function updateOrderFromTable(id, data, isArchive, getCouriers) {
    return (dispatch, getState) => {
    const url = isArchive ? urls.archive : urls.orders;
    dispatch(resetError('orders'));
    dispatch({ type: 'SET_LOADER', field: 'updateorder', value: id });

        return request({ method: 'put', url: `${url}/${id}`, data })
            .then((order) => {
                dispatch({ type: 'UPDATE_ORDER_TABLE', data: order, id });
                dispatch({ type: 'SET_LOADER', field: 'updateorder', value: false });

                if (getCouriers && data.point && data.point.id) {
                    const user = getState().user.info;
                    dispatch(fetchCouriers([order], user.role.id)).then((res) => {
                        dispatch({ type: 'ADD_COURIERS', data: res });
                    })
                }
                return order;
            })
            .catch(error => {
                dispatch(setError({ status: 508 }, 'orders'));
                dispatch({ type: 'SET_LOADER', field: 'updateorder', value: false });
                return false;
            });
    }
}

export function updateMarkedCodesOrder(id, markedCodes, isArchive, changeStatus) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'updateMarkedCodes', value: true });
        dispatch(resetError('updateMarkedCodes'));
        const user = getState().user.info;

        const orders = getState().orders.list;
        const url = isArchive ? urls.archive : urls.orders;

        let order = orders.find((item) => item.id === id);
        if (!order) {
            order = await request({ method: 'get', url: `${url}/${id}` });
        }

        const goods = order.goods.map((good) => {
            if (good.markedCodes && good.markedCodes.length === good.count) return good;
            if (markedCodes[good.id]) good.markedCodes = [...good.markedCodes || [], ...markedCodes[good.id]];
            return good;
        });

        const data = { goods };

        if (changeStatus && order.status !== 'cooked') {
            data.status = 'cooked';
            const dataStatus = optionsStatus.find((status) => status.value === 'cooked');
            data.visibleClientStatus = dataStatus ? dataStatus.client || null : null;

            let checkChangeStatusLog = null

            if(order.changeStatusLog) {
                if(typeof order.changeStatusLog === 'string') {
                    checkChangeStatusLog = JSON.parse(order.changeStatusLog)
                } else {
                    checkChangeStatusLog = order.changeStatusLog
                }
            }

            const date = new Date();
            const logName = String('cooked -' + (order.changeStatusLog ? order.changeStatusLog.length : 0) + '__' + moment(date).format('DD.MM.YYYY'));
        
            const username = user.name ? user.name : user.username;
            const roleDescription = user.role && user.role.description ? user.role.description : ''
            const userText = `${username} ${roleDescription}`;

            data.changeStatusLog = {
                ...checkChangeStatusLog,
                [logName]: {
                    status: 'cooked',
                    date: moment(date).format('DD.MM.YYYY HH:mm'),
                    user: userText
                }
            }
        }

        return request({ method: 'put', url: `${url}/${id}`, data })
            .then((order) => {
                dispatch({ type: 'UPDATE_ORDER_TABLE', data: order, id });
                dispatch({ type: 'SET_LOADER', field: 'updateMarkedCodes', value: false });
                return true;
            })
            .catch(error => {
                dispatch(setError({ status: 508 }, 'updateMarkedCodes'));
                dispatch({ type: 'SET_LOADER', field: 'updateMarkedCodes', value: false });
                return false;
            });
    }
}

export function fetchOrder(id, isArchive) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'order', value: true });

    const url = isArchive ? urls.archive : urls.orders;

    return request({ method: 'get', url: `${url}/${id}` })
        .then((response) => {
            const order = { ...response };
            if (!order.internalComment && order.comment) order.internalComment = order.comment;
            dispatch({ type: 'SET_ORDER', order });
            dispatch({ type: 'SET_LOADER', field: 'order', value: false });
            return order;
        })
        .catch(error => {
            dispatch(setError(error, 'order'));
            dispatch({ type: 'SET_LOADER', field: 'order', value: false });
            return null
        });
    }
}

export function setOrdersPaging(paging) {
    return dispatch => {
        dispatch({ type: 'SET_ORDERS_PAGING', paging });
    }
}

export function downloadRobovoiceCallByCallId(id) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'downloadRobovoiceCallByCall', value: true });
        dispatch(resetError('downloadRobovoiceCallByCall'));

        try {
            const response = await request({
                method: 'get',
                url: `/orders/downloadRobovoiceCallByCallId/${id}`,
                responseType: 'blob',
            });

            if (!response || response.size < 10) {
                console.error('Ошибка: файл не был получен или поврежден.');
                throw new Error('Ошибка загрузки файла');
            }

            const url = window.URL.createObjectURL(response);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `call-${id}.mp3`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            dispatch({ type: 'SET_LOADER', field: 'downloadRobovoiceCallByCall', value: false });
        } catch (error) {
            console.error('Ошибка при скачивании файла:', error);
            dispatch(setError(error, 'downloadRobovoiceCallByCall'));
            dispatch({ type: 'SET_LOADER', field: 'downloadRobovoiceCallByCall', value: false });
        }
    };
}

export function setFiscalDataOrder(data) {
    return dispatch => {
        dispatch({ type: 'SET_LOADER', field: 'updateorder', value: data.id });
        dispatch(updateOrder(data.id, {...data, ignoreFiscalized: true, ignoreConsumption: true }, false));
        dispatch({ type: 'SET_FISCAL_DATA_ORDER', data});
        dispatch({ type: 'SET_LOADER', field: 'updateorder', value: false });
        return true;
    }
}

export function sendOrderToFrontpad(data) {
    return async (dispatch) => {
        try {
            const response = await request({ method: 'post', url: `${urls.orders}/sendOrderToFrontpad`, data });

            return response;
        } catch (error) {
            throw error;
        }
    };
}

export function setBlockFiscal(value) {
    return dispatch => {
        dispatch({ type: 'SET_BLOCK_FISCAL', value });
    }
}

export function handleConsumption(isArchive) {
    return async (dispatch, getState) => {
        if (isArchive) return;
        dispatch({ type: 'SET_LOADER', field: 'orders', value: true });
        dispatch(resetError('orders'));
        const filters = getState().orders.filters;

        try {
            if(!filters.createdEndDate && !isArchive) filters.createdEndDate = new Date().setHours(23, 59, 59, 999);
            if(!filters.createdStartDate && !isArchive) filters.createdStartDate = new Date().setHours(0, 0, 0, 0);
            
            const start = moment(filters.createdStartDate).startOf('day');
            const end = moment(filters.createdEndDate).startOf('day');
            const diff = end.diff(start, 'days');
            
            if (Math.abs(diff) > 7) {
                dispatch({ type: 'SET_LOADER', field: 'orders', value: false });
                return { error: { message: 'Ручной расчет доступен только за период до 8и дней.'}};
            }

            if (!filters.points || filters.points.length === 0 || filters.points.length > 1) {
                dispatch({ type: 'SET_LOADER', field: 'orders', value: false });
                return { error: { message: 'Ручной расчет доступен только для 1го филиала за раз.'}};
            }

            const data = {};
            if (filters.createdStartDate) data['created_at_gte'] = moment(filters.createdStartDate).format('YYYY-MM-DD HH:mm:ss');
            if (filters.createdEndDate) data['created_at_lte'] = moment(filters.createdEndDate).format('YYYY-MM-DD HH:mm:ss');
            data.point = filters.points[0].value;

            const result = await  request({ method: 'post', url: urls.orders+'/handleConsumption', data });
            dispatch({ type: 'SET_LOADER', field: 'orders', value: false });
            return result;
        } catch (err) {
            dispatch({ type: 'SET_LOADER', field: 'orders', value: false });
            dispatch(setError(err, 'orders'));
        }
    }
}